import { Image, LI } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { useAuth } from "../../../../context/AuthContext";
const UserProfile = () => {
  const { user } = useAuth();
  return (
    <>
      <LI className="profile-nav onhover-dropdown">
        <div className="d-flex align-items-center gap-2">
          <Image
            className="rounded-circle"
            src={dynamicImage("avtar/3.jpg")}
            alt="avatar"
            style={{ width: "34px", height: "34px", objectFit: "cover" }}
          />
          <span className="dashboard-user-name">{user?.name || ""}</span>
        </div>
      </LI>
    </>
  );
};

export default UserProfile;
